import {Redirect, Route, Switch} from 'react-router-dom';
import React   from 'react';
import LoginContainer from './pages/Login/LoginContainer'
import 'bootstrap/dist/css/bootstrap.min.css';
import NotExistPage from "./pages/NotExistPage/NotExistPage";
import { ReactNotifications }  from 'react-notifications-component';

const NotAuthenticatedView=(props)=>{
    return(
        <div>
            <ReactNotifications/>
            <Switch>
            <Route path='/Login' render={() => <LoginContainer/>}/>
            <Route exact path='/'><Redirect to={"/Login"}/> </Route>
                <Route path='*' render={() => <LoginContainer/>}/>
            {/*<Route path='*' render={() => <NotExistPage/>}/>*/}
            </Switch>
        </div>
    )
}

export default NotAuthenticatedView;
